export var CorpVipLevel = /*#__PURE__*/function (CorpVipLevel) {
  CorpVipLevel[CorpVipLevel["INVALID_CORP_VIP_LEVEL"] = 0] = "INVALID_CORP_VIP_LEVEL";
  CorpVipLevel[CorpVipLevel["CORP_VIP_LEVEL_BASIC"] = 1] = "CORP_VIP_LEVEL_BASIC";
  CorpVipLevel[CorpVipLevel["CORP_VIP_LEVEL_PRO"] = 2] = "CORP_VIP_LEVEL_PRO";
  return CorpVipLevel;
}({});
//# sourceMappingURL=const.js.map